export default __webpack_public_path__ + "static/media/help-2.a2e97d2a.png";